import { render, staticRenderFns } from "./RoundSlider.vue?vue&type=template&id=35568576&scoped=true&"
import script from "./RoundSlider.vue?vue&type=script&lang=js&"
export * from "./RoundSlider.vue?vue&type=script&lang=js&"
import style0 from "./RoundSlider.vue?vue&type=style&index=0&id=35568576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35568576",
  null
  
)

export default component.exports